import platform from "platform";

export const getDeviceName = (siteName: string): string => {
    const deviceSuffix =
        platform.name != null && platform.os != null && platform.os.family != null ? ` - ${platform.name} (${platform.os.family})` : "";

    return siteName + deviceSuffix;
};
